import { createEvent, sample } from 'effector';
import { flushRequested, loadProjectFx, type ProjectLoadError } from '../../entities/library';
import { $project, $readOnly, projectClosed, projectLoaded } from '../../entities/project';
import { bindViewQuery } from '../../features/view-query';
import { routes } from '../../shared/routing';

/*
 * Project route: loads the project from local storage; view state lives in the URL
 * (features/view-query).
 */

export const projectLoadFailed = createEvent<ProjectLoadError['code']>();

const routeEntered = sample({
  clock: [routes.project.opened, routes.project.updated],
  source: { project: $project, readOnly: $readOnly },
  // A shared copy of the same project (the owner opened their own link) is replaced too.
  filter: ({ project, readOnly }, { params }) => readOnly || project?.id !== params.projectId,
  fn: (_, { params }) => params.projectId,
});

sample({ clock: routeEntered, target: loadProjectFx });
sample({ clock: loadProjectFx.doneData, target: projectLoaded });
sample({
  clock: loadProjectFx.failData,
  fn: (error) => ('code' in error ? (error as ProjectLoadError).code : 'invalid'),
  target: projectLoadFailed,
});
sample({ clock: projectLoadFailed, fn: () => undefined, target: routes.home.open });

sample({ clock: routes.project.closed, target: flushRequested });
sample({ clock: routes.project.closed, target: projectClosed });

bindViewQuery(routes.project);
